import { Routes } from "@angular/router";
import { BaseComponent } from "./views/layout/base/base.component";
import { authGuard } from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./views/pages/auth/auth.routes"),
  },
  {
    path: "",
    component: BaseComponent,
    canActivateChild: [authGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        loadChildren: () => import("./views/pages/dashboard/dashboard.routes"),
      },

      {
        path: "masters",
        loadChildren: () => import("./views/pages/masters/masters.routes"),
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("./views/pages/user-management/user-management.routes"),
      },
      {
        path: "reports",
        loadChildren: () => import("./views/pages/reports/reports.routes"),
      },
      {
        path: "settings",
        loadChildren: () => import("./views/pages/settings/settings.routes"),
      },
      {
        path: "ewallet",
        loadChildren: () => import("./views/pages/ewallet/ewallet.route"),
      },
      {
        path: "ai-agent",
        loadChildren: () => import("./views/pages/ai-agent/ai-agent.routes"),
      },
      {
        path: "notification",
        loadChildren: () => import("./views/pages/notification/notification.routes"),
      },
      {
        path: "support",
        loadChildren: () => import("./views/pages/support/support.routes"),
      },
      {
        path: "whatsapp",
        loadChildren: () => import("./views/pages/whatsapp/whatsapp.routes"),
      },
      {
        path: "operations",
        loadChildren: () => import("./views/pages/operations/operations.routes"),
      },

    ],
  },
  {
    path: "error",
    loadComponent: () =>
      import("./views/pages/error/error.component").then(
        (c) => c.ErrorComponent
      ),
  },
  {
    path: "error/:type",
    loadComponent: () =>
      import("./views/pages/error/error.component").then(
        (c) => c.ErrorComponent
      ),
  },
  { path: "**", redirectTo: "error/404", pathMatch: "full" },
];
